import { render, staticRenderFns } from "./StatusDetails.vue?vue&type=template&id=5c29014e"
import script from "./StatusDetails.vue?vue&type=script&lang=js"
export * from "./StatusDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports